type Block = { _type: string; children?: { text?: string }[] };

export const getTextFromPortableText = (blocks: Block[] | unknown[] = []): string => {
	return (
		(blocks as Block[])
			// loop through each block
			.map((block) => {
				// if it's not a text block with children,
				// return nothing
				if (block._type !== "block" || !block.children) {
					return "";
				}
				// loop through the children spans, and join the
				// text strings
				return block.children.map((child) => child.text ?? "").join("");
			})
			// join the paragraphs with a space
			.join(" ")
	);
};

export default getTextFromPortableText;
